import { render, staticRenderFns } from "./JurnalDetail.vue?vue&type=template&id=5603a2d1&"
import script from "./JurnalDetail.vue?vue&type=script&lang=js&"
export * from "./JurnalDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports